/**
 * Make every external image in an inline SVG opt into an anonymous CORS load.
 *
 * Customer resources are also drawn onto the Fabric canvas and exported with
 * toDataURL(). Loading the same URL first through an inline SVG without this
 * attribute can leave a non-CORS response in the browser cache. A later canvas
 * load can then fail even though the inline preview rendered successfully.
 */
export const withAnonymousSvgImages = (svg: string): string =>
  svg.replace(/<image\b[^>]*>/gi, (imageTag) => {
    const crossOriginAttribute =
      /\scrossorigin\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/i;

    if (crossOriginAttribute.test(imageTag)) {
      return imageTag.replace(crossOriginAttribute, ' crossorigin="anonymous"');
    }

    return imageTag.replace(/<image\b/i, '<image crossorigin="anonymous"');
  });
